"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useVideoContainerRef = void 0;

var _react = require("react");

/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal
 */
var GLOBAL_ID = 23;

var useVideoContainerRef = function useVideoContainerRef(debugId) {
  var ref = (0, _react.useRef)(0);

  if (!ref.current) {
    GLOBAL_ID++;
    ref.current = GLOBAL_ID + 0;
  }

  return ref;
};

exports.useVideoContainerRef = useVideoContainerRef;